export default "__VITE_ASSET__DEEmgPVG__"